<script lang="ts" setup>
export interface Props {
    title: string
}
defineProps<Props>()
</script>

<template>
    <el-container>
        <div class="d-flex flex-column gap-4 w-100">
            <div class="d-flex align-items-center">
                <h1 class="d-block my-4">
                    {{ title }}
                </h1>
                <div class="d-flex align-items-center ms-auto"></div>
            </div>
            <div class="d-flex flex-column gap-4 w-100">
                <slot />
            </div>
        </div>
    </el-container>
</template>

<style lang="scss" scoped></style>
